export const ModalType = {
  Gdpr: 'gdpr',
  Alert: 'alert',
};
